
import io from 'socket.io-client';


const socket = io(`${process.env.RAZZLE_REACT_APP_API_DOMAIN}`);

export default socket;
